var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPetrolDiesel = function SvgPetrolDiesel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.084 3.483a1.119 1.119 0 0 1 1.847.001l3.478 5.097a5.253 5.253 0 0 1 .623 4.685l-.07.201c-1.634 4.703-8.284 4.706-9.922.005l.367-.128-.367.128-.07-.2.368-.127-.368.128a5.253 5.253 0 0 1 .626-4.697l3.488-5.093Zm1.204.44a.34.34 0 0 0-.562 0L6.238 9.015a4.475 4.475 0 0 0-.533 4l-.365.128.365-.127.07.2c1.396 4.004 7.06 4 8.452-.005l.07-.202a4.475 4.475 0 0 0-.531-3.99l-3.478-5.097ZM7.315 11.15a.389.389 0 0 1 .429.345l.038.348a2.428 2.428 0 0 0 2.414 2.166.39.39 0 1 1 0 .779 3.206 3.206 0 0 1-3.188-2.86l-.038-.35a.389.389 0 0 1 .345-.428Z",
    fill: "currentColor"
  })));
};
export default SvgPetrolDiesel;